import { useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "@/api/client";

/** Floating feedback button + popup form. */
export default function FeedbackWidget() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async () => {
    if (!comment.trim() && rating === 0) return;
    setSending(true);
    try {
      await api.post("/feedback", { rating, comment: comment.trim(), page: window.location.pathname });
    } catch {
      // Silently ignore — feedback is best-effort
    }
    setSending(false);
    setSent(true);
    setTimeout(() => {
      setOpen(false);
      setSent(false);
      setRating(0);
      setComment("");
    }, 1800);
  };

  return (
    <>
      {/* FAB */}
      <button
        className="feedback-fab"
        onClick={() => setOpen((o) => !o)}
        aria-label={t("feedback.ariaLabel")}
        title={t("feedback.title")}
      >
        {open ? "✕" : "�"}
      </button>

      {/* Panel */}
      {open && (
        <div className="feedback-panel">
          {sent ? (
            <p style={{ textAlign: "center", margin: "24px 0" }}>{t("feedback.thanks")}</p>
          ) : (
            <>
              <h3>{t("feedback.heading")}</h3>
              <div className="feedback-rating">
                {[1, 2, 3, 4, 5].map((n) => (
                  <button
                    key={n}
                    className={n <= rating ? "active" : ""}
                    onClick={() => setRating(n)}
                    aria-label={t("feedback.ratingLabel", { n })}
                  >
                    ⭐
                  </button>
                ))}
              </div>
              <textarea
                placeholder={t("feedback.placeholder")}
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                maxLength={2000}
              />
              <div className="btn-actions">
                <button className="btn-secondary" onClick={() => setOpen(false)}>
                  {t("common.cancel")}
                </button>
                <button className="btn-primary" onClick={submit} disabled={sending}>
                  {sending ? t("feedback.sending") : t("feedback.send")}
                </button>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
}
